import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cart"
export default class extends Controller {
  static targets = [
    "quantityDisplay",
    "input",
    "remainingDisplay",
    "amountDisplay",
    "savingsDisplay", // Added target
    "checkoutLink",
  ];

  static values = {
    quantity: Number,
    available: Number,
    price: Number,
    savings: Number, // Added value
    url: String,
  };

  connect() {
    this.updateUI();
  }

  increment() {
    if (this.quantityValue < this.availableValue) {
      this.quantityValue++;
      this.updateUI();
    }
  }

  decrement() {
    if (this.quantityValue > 1) {
      this.quantityValue--;
      this.updateUI();
    }
  }

  updateUI() {
    // Update quantity displays at multiple places
    this.quantityDisplayTargets.forEach((el) => {
      el.textContent = this.quantityValue;
    });

    this.inputTarget.value = this.quantityValue;

    // Update remaining quantity display
    if (this.hasRemainingDisplayTarget) {
      const remaining = this.availableValue - this.quantityValue;
      this.remainingDisplayTargets.forEach((el) => {
        el.textContent = remaining;
      });
    }

    // Change amount at multiple places
    const totalAmount = this.quantityValue * this.priceValue;
    this.amountDisplayTargets.forEach((el) => {
      el.textContent = totalAmount.toFixed(2); // Format to 2 decimal places
    });

    // Update the Savings display
    if (this.hasSavingsDisplayTarget) {
      const totalSavings = this.quantityValue * this.savingsValue;
      this.savingsDisplayTargets.forEach((el) => {
        el.textContent = totalSavings.toFixed(2); // You can remove .toFixed(2) if you prefer round numbers
      });
    }

    this.toggleButtons();
  }

  toggleButtons() {
    this.element.querySelector(
      '[data-action="click->cart#decrement"]',
    ).disabled = this.quantityValue === 1;
    this.element.querySelector(
      '[data-action="click->cart#increment"]',
    ).disabled = this.quantityValue === this.availableValue;
  }
}
